import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-xl border-b border-background-300'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a
            href="/"
            className="flex items-center gap-2 group"
            onClick={(e) => { e.preventDefault(); navigate('/'); }}
          >
            <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
              <span className="text-foreground-50 font-heading font-bold text-sm">9</span>
            </div>
            <span className={`font-heading font-bold text-lg hidden sm:block whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-foreground-50' : 'text-foreground-50'
            }`}>
              911爆料网
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            <a
              href="/"
              onClick={(e) => { e.preventDefault(); navigate('/'); }}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-foreground-50'
                  : 'text-foreground-200 hover:text-foreground-50 hover:bg-background-200/60'
              }`}
            >
              首页
            </a>
            {categories.slice(0, 4).map((cat) => (
              <a
                key={cat.slug}
                href={`/category/${cat.slug}`}
                onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-foreground-50'
                    : 'text-foreground-200 hover:text-foreground-50 hover:bg-background-200/60'
                }`}
              >
                {cat.name}
              </a>
            ))}
            <a
              href="/about"
              onClick={(e) => { e.preventDefault(); navigate('/about'); }}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-foreground-50'
                  : 'text-foreground-200 hover:text-foreground-50 hover:bg-background-200/60'
              }`}
            >
              关于我们
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              scrolled ? 'text-foreground-400 hover:text-foreground-50' : 'text-foreground-200 hover:text-foreground-50'
            }`}
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-xl border-t border-background-300">
          <div className="px-4 py-3 flex flex-col gap-1">
            <a
              href="/"
              onClick={(e) => { e.preventDefault(); navigate('/'); }}
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-foreground-50'
                  : 'text-foreground-300 hover:bg-background-200'
              }`}
            >
              首页
            </a>
            {categories.map((cat) => (
              <a
                key={cat.slug}
                href={`/category/${cat.slug}`}
                onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-foreground-50'
                    : 'text-foreground-300 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </a>
            ))}
            <a
              href="/about"
              onClick={(e) => { e.preventDefault(); navigate('/about'); }}
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-foreground-50'
                  : 'text-foreground-300 hover:bg-background-200'
              }`}
            >
              关于我们
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}